import { Room, Visibility, VisibilityOff } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MultiButton from "../../components/buttons/MultiButton";
import StartIconButton from "../../components/buttons/StartIconButton";
import Info from "../../components/Info";
import useGetSessionType from "../../constants/sessionType";
import { useWeather, weatherType } from "../../constants/weatherType";
import Heatmap from "../Dashboard/Heatmap";
import { Pill } from "../Dashboard/Settings/Settings";

export default function OpenDataHeatmap({ interval, organization }) {
    //todo: filtri e dati di default per open data
    const { t } = useTranslation();
    let [filters, setFilters] = useState({
        isHomeWorkPath: null,
        minAge: 0,
        maxAge: 100,
        type: -1,
        minTime: "00:00",
        maxTime: "23:59",
        minDate: interval.start,
        maxDate: interval.end,
        weather: null
    });
    let sessionType = useGetSessionType();
    sessionType = sessionType.filter(st => st.id === 0 || st.id === 1);
    sessionType.unshift({ id: -1, name: t('all') })

    let [isShowingOrganizationArea, setIsShowingOrganizationArea] = useState(true)
    let [showMarkers, setShowMarkers] = useState({startStop: false, pauseResume: false});

    const [heatmapFilter, setHeatmapFilter] = useState('allSessions')
    const heatmapFilters = [
        'allSessions',
        'heatmapHomeWork',
        'heatmapNoHomeWork',
        'heatmapMuscular',
        'heatmapElectric'
    ];

    const bikeTypeFilters = [
        { key: 'bike', value: 0 },
        { key: 'eBike', value: 1 },
        { key: 'all', value: -1 },
    ]

    const sessionsTypeFilters = [
        { key: 'heatmapHomeWork', value: true },
        { key: 'heatmapNoHomeWork', value: false },
        { key: 'all', value: null },
    ]

    const weather = useWeather();

    useEffect(() => {
        setFilters({ ...filters, minDate: interval.start, maxDate: interval.end })
    }, [interval]);

    return (
        <Grid container>
            <Grid container justifyContent="space-between" xs={12}>
                <Grid item
                    sx={{
                        width: '25%',
                        minWidth: t('hideInitiativeArea').length + 'ex'
                    }}
                >
                    <StartIconButton
                        title={isShowingOrganizationArea ? t('hideInitiativeArea') : t('showInitiativeArea')}
                        onClick={() => setIsShowingOrganizationArea(prevState => !prevState)}
                        startIcon={isShowingOrganizationArea ? <VisibilityOff /> : <Visibility />} />
                </Grid>

                <Grid item alignSelf={'center'}>
                    <Typography variant='h6' color={'primary'} >{t('heatmapDescription')}</Typography>
                </Grid>

                <Grid item textAlign={'right'}
                    sx={{
                        width: '25%',
                        minWidth: t('hidePartials').length + 'ex'
                    }}
                >
                    <StartIconButton title={showMarkers.startStop ? t('hidePartials') : t('showPartials')}
                        onClick={() => setShowMarkers(value => value.startStop ? {startStop: false, pauseResume: false} : {startStop: true, pauseResume: false})}
                        startIcon={<Room />} />
                </Grid>

            </Grid>
            <Heatmap filters={filters} showOrganizationArea={isShowingOrganizationArea} showMarkers={showMarkers} overrideOrganization={organization} >
                <Box sx={{
                    position: 'absolute',
                    zIndex: 1,
                    marginTop: 'calc(16px + 3em)',
                    width: { md: '30vw', xs: 'calc(100vw - 96px)' },
                    minWidth: { md: '68em' },
                }}>
                    <Pill pill={{
                        id: 0,
                        title: t('filters'),
                        component: <Grid container direction='column' >
                            <Typography variant='subtitle1'>{t('weather')} <Info>{t('weatherInfo')}</Info></Typography>
                            {<MultiButton value={filters.weather} buttons={
                                Object.values(weatherType).map(
                                    w => ({
                                        value: w,
                                        onClick: () => setFilters({ ...filters, weather: w }),
                                        icon: weather[w].icon,
                                        tooltip: weather[w].tooltip
                                    })
                                )
                            } ></MultiButton>}


                            <Typography variant='subtitle1'>{t('bikeType')}</Typography>
                            {<MultiButton value={filters.type} buttons={
                                bikeTypeFilters.map(
                                    option => ({
                                        value: option.value,
                                        onClick: () => setFilters({
                                            ...filters,
                                            type: option.value,
                                        }),
                                        icon: t(option.key)
                                    })
                                )
                            } ></MultiButton>}

                            <Typography variant='subtitle1'>{t('sessionFilter')}</Typography>
                            {<MultiButton value={filters.isHomeWorkPath} buttons={
                                sessionsTypeFilters.map(
                                    option => ({
                                        value: option.value,
                                        onClick: () => setFilters({
                                            ...filters,
                                            isHomeWorkPath: option.value,
                                        }),
                                        icon: t(option.key)
                                    })
                                )
                            } ></MultiButton>}
                        </Grid>
                    }} index={0} />
                </Box>
            </Heatmap>
        </Grid>
    );
}
